import React, { useState } from 'react';
import './styles.css';
import { saveAs } from 'file-saver';

const ModelGenerator = () => {

    const [industry, setIndustry] = useState('');
    const [role, setRole] = useState('');
    const [organizationalFunction, setOrganizationalFunction] = useState('');
    const [proficiency, setProficiency] = useState('');
    
    const [processedModel, setProcessedModel] = useState('');
    
    const [loading, setLoading] = useState(false);
    
    const [showInfoPopup, setShowInfoPopup] = useState(false);
    
    const [additionalAnswers, setAdditionalAnswers] = useState([]);

    const [selectedSentences, setSelectedSentences] = useState([]);
    
    const [loadingCompleteModel, setLoadingCompleteModel] = useState(false);
  
    const [showInputForm, setShowInputForm] = useState(true);
    const [showOutput, setShowOutput] = useState(false);

    const [modelGenerated, setModelGenerated] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);

    const [anyCheckboxSelected, setAnyCheckboxSelected] = useState(false);

  
    const handleProcessModel  = async (e) => {

        const question = `You are now an expert in competency model making. Given this, perform this task: What are the top 20 skills with description of a ${role} working in the ${organizationalFunction} function in a ${industry} company? Don't type anything else, simply start the list from 1.`;

        try {
            setLoading(true); // Show the loading simulation
            setProcessedModel('');
            const response = await fetch('https://api-models.my-sdle.com/api/chat', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({ question }),
            });

            const data = await response.json();
            setModelGenerated(true);
            setProcessedModel(data.answer); 
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Hide the loading simulation
        }

            setShowInputForm(false);
            setShowOutput(true);
        };

    const handleInfoClick = () => {
        setShowInfoPopup(true);
    };

    const handlePopupClose = () => {
        setShowInfoPopup(false);
    };

    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter((i) => i !== item));
            setSelectedSentences(selectedSentences.filter((i) => i !== item)); // Remove from selectedSentences
        } else {
            setSelectedItems([...selectedItems, item]);
            setSelectedSentences([...selectedSentences, item]); // Add to selectedSentences
        }

        setAnyCheckboxSelected(selectedItems.length > 0);
    };

    const handleToggleCheckboxes = () => {
        if (anyCheckboxSelected) {
            setSelectedItems([]);
            setSelectedSentences([]);
        } else {
            setSelectedItems(processedModel.split('\n').map(line => line.trim()).filter(line => line !== ''));
            setSelectedSentences(processedModel.split('\n').map(line => line.trim()).filter(line => line !== ''));
        }
        setAnyCheckboxSelected(!anyCheckboxSelected);
    };
    
    

    const handleLoadMoreSkills = async (e) => {
        const question = `You are now an expert in competency model making. Given this, perform this task: What are 5 other skills with description of a ${role} working in the ${organizationalFunction} function in a ${industry} company? Don't type anything else, simply start the list from 1.`;

        try {
        const response = await fetch('https://api-models.my-sdle.com/api/chat', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ question }),
        });

        const data = await response.json();
        setProcessedModel((prevAnswer) => prevAnswer + '\n' + data.answer);
        } catch (error) {
        console.error(error);
        }
    };

    const handleCompleteModel = async (e) => {
        try {
            console.log('handleCompleteModel called'); // Debugging statement
            
            setLoading(true); // Show the loading simulation for the "Complete the Model" button
            
            const options = [
                "3 point scale:\nLevel 1: General\nLevel 2: Skilled\nLevel 3: Expert",
                "4 point scale:\nLevel 1: Limited\nLevel 2: General\nLevel 3: Skilled\nLevel 4: Expert",
                "5 point scale:\nLevel 1: Limited\nLevel 2: General\nLevel 3: Skilled\nLevel 4: Advanced\nLevel 5: Expert",

              ];
              

            const promises = selectedSentences.map((selectedSkill) => {
                const question = `You are now an expert in competency model making. Given this, perform this task: What are the behavioral examples for ${selectedSkill} for a ${role} working in the ${organizationalFunction} function in a ${industry} company? Please dont include any other intro statements and only output the levels themselves and their detailed description. Use ${options[proficiency]} point scale outline to output the details about the behavioral example observed.`;
    
                return fetch('https://api-models.my-sdle.com/api/chat', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ question }),
                }).then((response) => response.json());
            });
            


            const responses = await Promise.all(promises);
            console.log('API Responses:', responses);
            const answers = responses.map((data, index) => {
                const selectedSkill = selectedSentences[index];
                const levels = data.answer
                    .split(/Level \d+: /)
                    .filter((item) => item.trim() !== "")
                    .map((level) => '\n\n\n' + level.trim()); // Add three '\n' before each level
    
                const header = levels.shift();
                return { skill: selectedSkill, header, levels };
            });

            // Update the additionalAnswers state with the API response data
            setAdditionalAnswers((prevAnswers) => [...prevAnswers, ...answers]);
        } catch (error) {
            console.error('handleCompleteModel Error:', error);
        } finally {
            setLoading(false); // Hide the loading simulation
        }
    };

    const handleDownloadSelectedSkills = () => {
        const selectedSkillsText = additionalAnswers
        .map(
            (additionalAnswer) =>
            `${additionalAnswer.skill}\n${additionalAnswer.header}\n${additionalAnswer.levels.join('\n')}\n\n`
        )
        .join('\n');
    
        const blob = new Blob([selectedSkillsText], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, 'selected_skills_and_behavioral_examples.txt'); // Download the blob as a text file
    };

    
    return (
        <div className="model-generator">
            <div className="centered-content">
                {modelGenerated ? (
                    <div className="answer-container"> 
                        <div className="table-container">
                            <table className="api-response-table">
                                <tbody>
                                {processedModel.split('\n').map((line, index) => {
                                    const trimmedLine = line.trim();
                                    if (trimmedLine !== '') {
                                        const pointMatch = trimmedLine.match(/^\d+\.\s+/);
                                        if (pointMatch) {
                                            const content = trimmedLine.replace(/^\d+\.\s+/, '');
                                            return (
                                            <tr key={index}>
                                                <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedItems.includes(trimmedLine)}
                                                    onChange={() => handleCheckboxChange(trimmedLine)}
                                                />
                                                </td>
                                                <td>{content}</td>
                                            </tr>
                                            );
                                        }
                                    }
                                    return null;
                                })}
                                </tbody>
                            </table>
                        </div>
                        <div className="button-container">
                            <button onClick={handleCompleteModel} disabled={loading}>
                                Generate Model
                            </button>
                            <button onClick={handleLoadMoreSkills} disabled={loading}>
                                Load More Skills
                            </button>
                            <button onClick={handleToggleCheckboxes}>
                                {anyCheckboxSelected ? "Deselect All" : "Select All"}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="input-container">
                        <input
                        type="text"
                        placeholder="Role"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        />
                        <input
                        type="text"
                        placeholder="Organizational Function"
                        value={organizationalFunction}
                        onChange={(e) => setOrganizationalFunction(e.target.value)}
                        />
                        <input
                        type="text"
                        placeholder="Industry"
                        value={industry}
                        onChange={(e) => setIndustry(e.target.value)}
                        />
                        <select
                        value={proficiency}
                        onChange={(e) => setProficiency(parseInt(e.target.value))}
                        >
                        <option value={0}>Proficiency: 3</option>
                        <option value={1}>Proficiency: 4</option>
                        <option value={2}>Proficiency: 5</option>
                        </select>
                        <button onClick={handleProcessModel} disabled={loading}>
                        {loading ? 'Generating Options...' : 'Start Model Creation'}
                        </button>
                    </div>
                )}
                {additionalAnswers.length > 0 && (
                    <div className="additional-answers-container">
                        <button
                            className="button-style"
                            onClick={handleDownloadSelectedSkills}
                            disabled={selectedSentences.length === 0}
                        >
                            Download Selected Skills and Behavioral Examples
                        </button>
                        <h2>Completed Model Output</h2>
                        {console.log('additionalAnswers:', additionalAnswers)}
                        <div className="scrollable-output">
                            {additionalAnswers.map((additionalAnswer, index) => (
                                <div key={index} className="output-container additional-output">
                                    <h3>{additionalAnswer.skill}</h3>
                                    <div>{additionalAnswer.header}</div>
                                    <div className="level-list">
                                        {additionalAnswer.levels.map((level, levelIndex) => (
                                            <div key={levelIndex} className="level-item">
                                                {level}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};  

export default ModelGenerator;
